<script setup lang="ts">
import GetAttributeTagOptionsResponseItem from "@/api/Weeek/dataSource/api/project-manager/weeek/i-services/models/response/GetAttributeTagOptionsResponseItem";
import { TaskParameter, TaskParameterTypeEnum } from "@/components";
import { TagModel } from "@/components/task-forms/models";
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmInput,
  TirPmMultiselect,
  TirPmSelect,
} from "tir-components";
import { ArrowPathIcon, TrashIcon } from "tir-style-system/icons/outline";
import { computed, onMounted, PropType, ref, watch } from "vue";

/**Параметры */
const props = defineProps({
  /**индекс статуса */
  index: { type: Number },
  /**Данные статусов weeek */
  tagsDataWeeek: { type: Array as PropType<GetAttributeTagOptionsResponseItem[]> },
  /**Статус weeek */
  tagDataWeeek: { type: Object as PropType<GetAttributeTagOptionsResponseItem> },
  /**Теги проекта ПМ */
  tagsProjectPm: { type: Array as PropType<TagModel[]> },
});
/**События */
const emit = defineEmits<{
  /**Поиск тегов */
  searchTags: [value: string];
}>();

/**Выбранный тег */
const selectedTag = ref<TagModel[]>([]);

watch(
  () => props.tagsProjectPm,
  () => {
    if (!selectedTag.value.length) {
      selectedTag.value = props.tagsProjectPm.find((tag) => tag.Id === props.tagDataWeeek?.TagId)
        ? [props.tagsProjectPm.find((tag) => tag.Id === props.tagDataWeeek?.TagId)!]
        : [];
    }
  },
  { immediate: true },
);

/**Выбрать тег */
const selectTag = (tag: TagModel) => {
  props.tagDataWeeek.TagId = tag.Id;
};
/**Удаление тега */
const removeTagsWeeek = (index: number) => {
  props.tagsDataWeeek.splice(index, 1);
};
</script>
<template>
  <div class="weeek-tags-item__block">
    <TirPmInput
      class="weeek-tags-item__input"
      label="Статус с weeek.ru"
      :isWithHint="false"
      v-model="tagDataWeeek.WeeekTagName"
    />
    <ArrowPathIcon class="weeek-tags-item__icon" />
    <TirPmMultiselect
      :isSearchLocal="false"
      :selected-options="selectedTag"
      :options="tagsProjectPm"
      showOnHover
      popoverWidth="30rem"
      popoverClasses="weeek-tags-item__popover"
      label="Тег на замену"
      searchInputLabel="Поиск по тегам"
      class="weeek-tags-item__multiselect"
      noTeleport
      disableContentBlur
      @updateSearch="emit('searchTags', $event)"
      @onClose="emit('searchTags', $event)"
    >
      <template class="flex" #optionList="{ option }">
        <div class="weeek-tags-item__parameter-option-block" @click="selectTag(option)">
          <div class="weeek-tags-item__parameter-option">
            <TaskParameter :data="option" :type="TaskParameterTypeEnum.Tag" hide-remove preview />
          </div>
        </div>
      </template>
      <template #selectedContent>
        <div v-for="tag in selectedTag" :key="index" class="weeek-tags-item__parameter">
          <TaskParameter :data="tag" :type="TaskParameterTypeEnum.Tag" hide-remove preview />
        </div>
      </template>
    </TirPmMultiselect>
    <TirPmButton :variant="TirPmButtonVariantEnum.LinkState" @click="removeTagsWeeek(index)">
      <template #leftSlot>
        <TrashIcon class="weeek-tags-item__icon-trash" />
      </template>
    </TirPmButton>
  </div>
</template>
<style scoped lang="scss">
.weeek-tags-item {
  &__parameter-option {
    width: max-content;
  }
  &__block {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
  &__icon {
    min-width: 1.5rem;
    height: 1.5rem;
    color: var(--text-secondary, #686c73);
  }
  &__parameter-option-block {
    width: 100%;
    padding: 0.75rem;
  }
  &__icon-trash {
    min-width: 1.5rem;
    height: 1.5rem;
  }
  &__input {
    width: 100%;
  }
}
.weeek-tags-item__multiselect {
  width: 100% !important;
}
</style>
<style>
.weeek-tags-item__multiselect .tir-popover_element .tir-pm-multiselect__area {
  width: 100% !important;

  .tir-pm-multiselect__desc-select {
    .tir-pm-multiselect__selected-item {
      display: flex;
    }
  }
}

.weeek-tags-item__popover
  .tir-pm-multiselect__popover-content
  .tir-pm-multiselect__selected-list
  .tir-pm-multiselect__selected-list-inner {
  display: none;
}
</style>
